import styled from 'styled-components';
export const Select = styled.select`
  width: 100%;
  padding: 0.85rem 1rem;
  border: 1px solid #ced4da;
  border-radius: 6px;
  font-size: 1rem;
  color: #495057;
  background-color: #fff;
  appearance: none; /* Remove default arrow */
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='%236c757d'%3E%3Cpath d='M7 10l5 5 5-5z'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 0.7rem center;
  background-size: 1em;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;

  &:focus {
    border-color: #007bff;
    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
    outline: none;
  }
`;

interface ButtonProps {
  variant?: 'primary'|'outline' | 'danger';
  size?: 'sm';
  fullWidth?: boolean;
}

export const MediaUploadContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  border: 1px dashed #ced4da;
  border-radius: 8px;
  padding: 1rem;
  background-color: #f8f9fa;
`;

export const MediaUploadButton = styled.label`
  width: 100px;
  height: 100px;
  border: 2px dashed #007bff;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: #007bff;
  cursor: pointer;
  background-color: #e7f3ff;
  transition: all 0.2s ease;

  &:hover {
    background-color: #d1e7ff;
  }

  svg {
    margin-bottom: 0.25rem;
  }

  span {
    font-size: 0.85rem;
  }
`;

export const MediaUploadInput = styled.input`
  display: none;
`;



export const ListingImage = styled.div`
  width: 150px;
  height: 120px;
  flex-shrink: 0;
  background-color: #f0f0f0;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  border-right: 1px solid #eee;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

export const ListingDetails = styled.div`
  flex-grow: 1;
  padding: 1rem;
`;

export const ListingTitle = styled.h3`
  font-size: 1.25rem;
  color: #1a202c;
  margin-top: 0;
  margin-bottom: 0.5rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;

  small {
    font-size: 0.75em;
    color: #6c757d;
    font-weight: normal;
  }
`;

export const PremiumCheckboxContainer = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 1.5rem;
`;

export const PremiumCheckbox = styled.input`
  margin-right: 0.75rem;
  width: 1.25rem;
  height: 1.25rem;
  cursor: pointer;
`;

export const PremiumLabel = styled.label`
  font-weight: 600;
  color: #333;
  display: flex;
  align-items: center;
  cursor: pointer;
`;

export const PremiumInfo = styled.span`
  margin-left: 0.75rem;
  font-size: 0.85rem;
  color: #6b7280;
  font-weight: normal;
`;

// New styled component for contact inputs on the same row
export const ContactInputsContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr; /* Two columns, equal width */
  gap: 1rem; /* Space between inputs */

  @media (max-width: 768px) {
    grid-template-columns: 1fr; /* Stack on smaller screens */
  }
`;

// New styled component for the Leaflet map container
export const MapContainerWrapper = styled.div`
  height: 300px;
  width: 100%;
  border: 1px solid #ced4da;
  border-radius: 6px;
  overflow: hidden; /* Ensures the map stays within bounds */
`;


export const ListingsContainer = styled.div`
  background-color: #f8f9fa;
  min-height: 100vh;
  font-family: 'Inter', sans-serif;
`;

export const DashboardHeader = styled.header`
  background-color: #fff;
  padding: 1.5rem 2rem;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.5rem;
  
  @media (max-width: 768px) {
    padding: 1rem;
    flex-direction: column;
    align-items: flex-start;
    gap: 1rem;
  }
`;

export const DashboardTitle = styled.h1`
  margin: 0;
  font-size: 1.5rem;
  color: #333;
  display: flex;
  align-items: center;
  gap: 0.75rem;
  
  svg {
    color: #4a6bff;
  }
`;

export const DashboardMeta = styled.div`
  display: flex;
  gap: 1.5rem;
  margin-top: 0.5rem;
  font-size: 0.9rem;
  color: #666;
  
  span {
    display: flex;
    align-items: center;
    gap: 0.5rem;
  }
  
  strong {
    color: #333;
    font-weight: 600;
  }
  
  @media (max-width: 768px) {
    flex-direction: column;
    gap: 0.5rem;
    margin-top: 0.75rem;
    font-size: 0.85rem;
  }
  
  @media (max-width: 480px) {
    span {
      flex-wrap: wrap;
      font-size: 0.8rem;
    }
  }
`;

export const Tabs = styled.div`
  display: flex;
  border-bottom: 1px solid #e0e6ed;
  padding: 0 2rem;
  margin-bottom: 1.5rem;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  
  @media (max-width: 768px) {
    padding: 0 1rem;
    gap: 0.5rem;
    
    /* Hide scrollbar but keep functionality */
    scrollbar-width: none;
    -ms-overflow-style: none;
    &::-webkit-scrollbar {
      display: none;
    }
  }
`;

export const Tab = styled.button<{active: boolean }>`
  padding: 0.75rem 1.5rem;
  background: none;
  border: none;
  border-bottom: 3px solid ${props => props.active ? '#4a6bff' : 'transparent'};
  color: ${props => props.active ? '#4a6bff' : '#666'};
  font-weight: ${props => props.active ? '600' : '500'};
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  white-space: nowrap;
  flex-shrink: 0;
  
  &:hover {
    color: #4a6bff;
  }
  
  @media (max-width: 768px) {
    padding: 0.75rem 1rem;
    font-size: 0.85rem;
  }
  
  @media (max-width: 480px) {
    padding: 0.75rem 0.5rem;
    min-width: 44px; /* Minimum touch target size */
    justify-content: center;
    
    /* Hide text spans, keep only TabIcon spans */
    > span:last-child {
      display: none;
    }
  }
`;

export const TabIcon = styled.span`
  font-size: 0.9rem;
`;

export const DashboardContent = styled.div`
  padding: 0 2rem 2rem;
  
  @media (max-width: 768px) {
    padding: 0 1rem 2rem;
  }
`;

export const ContentSection = styled.section`
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  padding: 1.5rem;
  margin-bottom: 1.5rem;
`;

export const SectionHeader = styled.div`
  margin-bottom: 1.5rem;
  
  h2 {
    margin: 0 0 0.25rem;
    font-size: 1.25rem;
    color: #333;
    display: flex;
    align-items: center;
    gap: 0.75rem;
  }
  
  p {
    margin: 0;
    color: #666;
    font-size: 0.9rem;
  }
`;

export const CardGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 1.5rem;
`;


export const CardHeader = styled.div`
  position: relative;
`;

export const CardBody = styled.div`
  padding: 1rem;
`;

interface ListingItemProps {
  variant?: 'compact';
}

export const ListingItem = styled.div<ListingItemProps>`
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  overflow: hidden;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  
  ${props => !props.variant && `
    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    }
  `}
  
  ${props => props.variant === 'compact' && `
    display: flex;
    align-items: center;
    gap: 1rem;
    padding: 0.75rem;
    margin-bottom: 0.75rem;
  `}
`;

export const ListingMeta = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
  margin-bottom: 0.75rem;
  font-size: 0.85rem;
  color: #666;
  
  span {
    display: flex;
    align-items: center;
    gap: 0.25rem;
  }
  
  svg {
    font-size: 0.8rem;
    color: #888;
  }
  
  ${ListingItem}[variant="compact"] & {
    margin-bottom: 0;
    gap: 0.5rem;
    
    span {
      white-space: nowrap;
    }
  }
`;

export const StatusBadge = styled.span<{sold: boolean }>`
  display: inline-block;
  padding: 0.25rem 0.5rem;
  border-radius: 4px;
  font-size: 0.75rem;
  font-weight: 600;
  background-color: ${props => props.sold ? '#f8f9fa' : '#e6f7ee'};
  color: ${props => props.sold ? '#666' : '#28a745'};
  border: 1px solid ${props => props.sold ? '#e0e6ed' : '#c3e6d1'};
  
  ${ListingItem}[variant="compact"] & {
    margin-left: auto;
  }
`;

export const ListingActions = styled.div`
  display: flex;
  gap: 0.5rem;
  margin-top: 1rem;
  
  ${ListingItem}[variant="compact"] & {
    display: none;
  }
`;

export const Button = styled.button<{
  variant?: 'outline' | 'danger', 
  size?: 'sm',
  fullWidth?: boolean 
}>`
  padding: ${props => props.size === 'sm' ? '0.4rem 0.75rem' : '0.5rem 1rem'};
  background-color: ${props => 
    props.variant === 'outline' ? 'transparent' : 
    props.variant === 'danger' ? '#dc3545' : '#4a6bff'};
  color: ${props => 
    props.variant === 'outline' ? '#4a6bff' : 
    props.variant === 'danger' ? '#fff' : '#fff'};
  border: 1px solid ${props => 
    props.variant === 'outline' ? '#4a6bff' : 
    props.variant === 'danger' ? '#dc3545' : '#4a6bff'};
  border-radius: 4px;
  font-size: ${props => props.size === 'sm' ? '0.8rem' : '0.9rem'};
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  width: ${props => props.fullWidth ? '100%' : 'auto'};
  
  &:hover {
    background-color: ${props => 
      props.variant === 'outline' ? '#f0f4ff' : 
      props.variant === 'danger' ? '#c82333' : '#3a56db'};
    border-color: ${props => 
      props.variant === 'outline' ? '#3a56db' : 
      props.variant === 'danger' ? '#c82333' : '#3a56db'};
  }
  
  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

export const DashboardStatsContainer = styled.div<{variant?: 'compact' }>`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  gap: 1rem;
  
  ${props => props.variant === 'compact' && `
    grid-template-columns: repeat(3, 1fr);
  `}
`;

export const StatCard = styled.div<{variant?: 'compact' }>`
  background-color: #fff;
  border-radius: 8px;
  padding: ${props => props.variant === 'compact' ? '0.75rem' : '1.25rem'};
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  text-align: center;
  
  ${props => !props.variant && `
    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    }
  `}
`;

export const StatIcon = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: #f0f4ff;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 0.75rem;
  color: #4a6bff;
  font-size: 1rem;
`;

export const StatValue = styled.div`
  font-size: 1.5rem;
  font-weight: 700;
  color: #333;
  margin-bottom: 0.25rem;
`;

export const StatLabel = styled.div`
  font-size: 0.85rem;
  color: #666;
`;

export const FormSection = styled.div`
  margin-top: 1rem;
`;

export const FormRow = styled.div`
  display: flex;
  gap: 1rem;
  margin-bottom: 1rem;
  
  > * {
    flex: 1;
  }
`;

export const FormGroup = styled.div`
  margin-bottom: 1rem;
`;

export const Label = styled.label`
  display: block;
  margin-bottom: 0.5rem;
  font-size: 0.9rem;
  font-weight: 500;
  color: #333;
`;

export const Input = styled.input`
  width: 100%;
  padding: 0.5rem 0.75rem;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 0.9rem;
  transition: border-color 0.2s ease;
  
  &:focus {
    outline: none;
    border-color: #4a6bff;
  }
  
  &:disabled {
    background-color: #f8f9fa;
    cursor: not-allowed;
  }
`;

export const TextArea = styled.textarea`
  width: 100%;
  padding: 0.5rem 0.75rem;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 0.9rem;
  transition: border-color 0.2s ease;
  resize: vertical;
  
  &:focus {
    outline: none;
    border-color: #4a6bff;
  }
  
  &:disabled {
    background-color: #f8f9fa;
    cursor: not-allowed;
  }
`;

export const LoadingMessage = styled.div`
  padding: 2rem;
  text-align: center;
  color: #666;
  font-size: 1rem;
`;

export const ErrorMessage = styled.div`
  padding: 2rem;
  text-align: center;
  color: #dc3545;
  font-size: 1rem;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
`;

export const EmptyState = styled.div`
  padding: 2rem;
  text-align: center;
  color: #666;
`;

export const EmptyStateIcon = styled.div`
  font-size: 3rem;
  color: #ccc;
  margin-bottom: 1rem;
`;

export const EmptyStateText = styled.div`
  max-width: 400px;
  margin: 0 auto;
  
  h3 {
    margin: 0 0 0.5rem;
    color: #333;
  }
  
  p {
    margin: 0 0 1.5rem;
    font-size: 0.95rem;
  }
`;

export const MediaPreview = styled.div`
  margin: 0.75rem 0;
  
  small {
    display: block;
    margin-bottom: 0.5rem;
    font-size: 0.8rem;
    color: #888;
  }
`;

export const MediaGrid = styled.div`
  display: flex;
  gap: 0.5rem;
  
  > div {
    width: 40px;
    height: 40px;
    border-radius: 4px;
    overflow: hidden;
    background-color: #f5f7fa;
    position: relative;
    
    img, video {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
    
    &.more-count {
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: #e0e6ed;
      color: #666;
      font-size: 0.8rem;
      font-weight: 600;
    }
  }
`;

export const Divider = styled.div`
  height: 1px;
  background-color: #e0e6ed;
  margin: 1.5rem 0;
`;

export const TwoColumnLayout = styled.div`
  display: grid;
  grid-template-columns: 1fr 300px;
  gap: 1.5rem;
  
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

export const ProfileCard = styled.div`
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  padding: 1.5rem;
  margin-bottom: 1.5rem;
`;